import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useTranslation } from '@/store/languageStore';
import { useNavigateBack } from '@/utils/navigationBack';

export interface PageBackButtonProps {
  onBack?: () => void;
  backTo?: string;
  fallback?: string;
  className?: string;
}

export function PageBackButton({
  onBack,
  backTo,
  fallback,
  className = 'p-2 hover:bg-bgElevated rounded-lg transition-colors',
}: PageBackButtonProps) {
  const { t } = useTranslation();
  const goBack = useNavigateBack(fallback);

  return (
    <button
      type="button"
      onClick={() => goBack({ onBack, backTo })}
      className={className}
      aria-label={t('common.back')}
      title={t('common.back')}
    >
      <ArrowLeftIcon className="w-5 h-5 text-textDefault" />
    </button>
  );
}
